var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLayout',{attrs:{"title":"Historical data and forecasts","half":"","units":_vm.units,"palette":"default-highlight"},scopedSlots:_vm._u([{key:"params",fn:function(){return [_c('ControlGroup',[_c('ControlGroup',{staticClass:"case-select"},[(_vm.allowCaseSelection)?_c('RadioGroup',{attrs:{"options":[
            { label: 'Main case', value: 'MAIN' },
            { label: 'Accelerated case', value: 'ACC' },
            { label: 'Compare cases', value: 'BOTH' },
          ]},model:{value:(_vm.selectedCase),callback:function ($$v) {_vm.selectedCase=$$v},expression:"selectedCase"}}):_vm._e()],1),(_vm.selectedFlow === 'Capacity' && _vm.targetText)?_c('ControlGroup',[_c('div',{staticClass:"target-text"},[_c('p',{staticClass:"f-ui-2-bold"},[_vm._v(" 2030 renewable energy capacity ambition note ")]),_c('div',{staticClass:"f-ui-2",domProps:{"innerHTML":_vm._s(_vm.targetText)}})])]):_vm._e()],1)]},proxy:true},(_vm.note)?{key:"notes",fn:function(){return [_vm._v(" "+_vm._s(_vm.note)+" ")]},proxy:true}:null],null,true)},[_c('DataSlicer',{attrs:{"data":_vm.processedData,"xAxisDimension":"year","yAxisDimension":"product","valueDimension":"value","childElementType":null},scopedSlots:_vm._u([{key:"default",fn:function({ slicedData, xAxisCategories }){return [_c('Chart',{key:`flowByYear${_vm.selectedFlow}`,attrs:{"options":_vm.buildOptions(
          {
            chart: {
              height: 400,
            },
            series: slicedData ? _vm.formatSeries(slicedData) : [],
            plotOptions: {
              column: {
                // groupPadding: 0.05,
                pointPadding: 0,
              },
            },
            yAxis: {
              max: _vm.getMax(_vm.data, xAxisCategories),
              reversedStacks: true,
              plotLines: _vm.showTripling
                ? [
                    {
                      value: 11000,
                      className: 'highcharts-dotted',
                      zIndex: 99,
                      label: {
                        text: 'COP28 goal of tripling global renewable capacity by 2030',
                      },
                    },
                    {
                      value: 0,
                      className: 'highcharts-zero-axis',
                      zIndex: 99,
                    },
                  ]
                : [
                    {
                      value: 0,
                      className: 'highcharts-zero-axis',
                      zIndex: 99,
                    },
                  ],
            },
            xAxis: {
              plotBands: [
                {
                  from: _vm.projectionYear - 0.5,
                  to: 2050,
                  label: {
                    align: 'left',
                    text:
                      _vm.selectedCase === 'BOTH'
                        ? 'Forecast<br>Main vs.<br>accelerated case'
                        : `Forecast<br>${
                            _vm.selectedCase === 'ACC' ? 'Accelerated' : 'Main'
                          } case`,
                  },
                },
              ],
            },
            tooltip: {
              valueSuffix: ` ${_vm.units}`,
            },
            legend: {
              enabled: true,
              reversed: true,
              align: 'right',
              verticalAlign: 'middle',
              layout: 'vertical',
              width: '20%',
              floating: false,
            },
          },
          'column'
        ),"updateArgs":[true, true, true]}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }